import { render, staticRenderFns } from "./supehome.vue?vue&type=template&id=58970490&scoped=true&"
import script from "./supehome.vue?vue&type=script&lang=js&"
export * from "./supehome.vue?vue&type=script&lang=js&"
import style0 from "./supehome.vue?vue&type=style&index=0&id=58970490&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58970490",
  null
  
)

export default component.exports